import CookieBanner from '@/components/CookieBanner';
import useConsentScript from '@/hooks/useConsentScript';
import AppRouter from '@/router/AppRouter';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export default function App() {
  useConsentScript();
  return (
    <>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      <AppRouter />
      <CookieBanner />
    </>
  );
}
